export interface ProfileHotOfferPayload {
  id: string;
  title: string;
  description: string;
  primaryLabel: string;
  secondaryLabel: string;
  showAgainAfterHours: number;
  /** Может быть внутренним роутом (`/path`) или внешним URL (`https://...`). */
  primaryLink?: string;
  /** Пустая строка трактуется как отсутствие toast-сообщения. */
  successToast?: string;
}

const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

export const parseProfileHotOfferPayload = (payload: unknown): ProfileHotOfferPayload | null => {
  if (!payload) {
    return null;
  }

  let parsedPayload = payload;

  if (typeof payload === 'string') {
    try {
      parsedPayload = JSON.parse(payload);
    } catch {
      return null;
    }
  }

  if (!isObject(parsedPayload)) {
    return null;
  }

  if (
    typeof parsedPayload.id !== 'string' ||
    typeof parsedPayload.title !== 'string' ||
    typeof parsedPayload.description !== 'string' ||
    typeof parsedPayload.primaryLabel !== 'string' ||
    typeof parsedPayload.secondaryLabel !== 'string' ||
    typeof parsedPayload.showAgainAfterHours !== 'number' ||
    !Number.isFinite(parsedPayload.showAgainAfterHours) ||
    parsedPayload.showAgainAfterHours <= 0
  ) {
    return null;
  }

  if (parsedPayload.primaryLink !== undefined && typeof parsedPayload.primaryLink !== 'string') {
    return null;
  }

  if (parsedPayload.successToast !== undefined && typeof parsedPayload.successToast !== 'string') {
    return null;
  }

  return {
    id: parsedPayload.id,
    title: parsedPayload.title,
    description: parsedPayload.description,
    primaryLabel: parsedPayload.primaryLabel,
    secondaryLabel: parsedPayload.secondaryLabel,
    showAgainAfterHours: parsedPayload.showAgainAfterHours,
    primaryLink: parsedPayload.primaryLink,
    successToast: parsedPayload.successToast,
  };
};

export const getProfileHotOfferSnoozedUntilStorageKey = (offerId: string) =>
  `zingizi_profile_hot_offer_snoozed_until:${offerId}`;

export const getProfileHotOfferCompletedStorageKey = (offerId: string) =>
  `zingizi_profile_hot_offer_completed:${offerId}`;
